import type { MessageKey } from './schema'

/**
 * Marks a message key used outside a render call — nav titles, `meta.pageTitle`, breadcrumbs, option labels —
 * so that `vue-tsc` checks it against the schema and the ESLint vue-i18n rules and `pnpm i18n:check` count it as
 * used (they recognise any call named `t`). Returns the key unchanged; translate it where it is displayed.
 *
 *   title: keys.t('common.nav.employees')
 */
export const keys = {
  t: <K extends MessageKey>(key: K): K => key,
}
